/** Name matching is an advisory UI aid. The server owns client identity and
 * enforces uniqueness; a similar spelling never assigns or merges a project. */
export function normalizeClientName(value: string): string {
  return value.normalize('NFKC').trim().replace(/\s+/gu, ' ').toLocaleLowerCase('en');
}

function distance(a: string, b: string): number {
  let row = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const next = [i];
    for (let j = 1; j <= b.length; j++) {
      next[j] = Math.min(next[j - 1] + 1, row[j] + 1, row[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    }
    row = next;
  }
  return row[b.length];
}

export function findClientMatches<T extends { name: string }>(clients: T[], name: string): Array<{ client: T; exact: boolean }> {
  const query = normalizeClientName(name);
  if (!query) return [];
  return clients.map(client => {
    const key = normalizeClientName(client.name);
    const exact = key === query;
    return { client, exact, score: exact ? 0 : query.length < 3 ? 1 : distance(key, query) / Math.max(key.length, query.length) };
  }).filter(match => match.exact || match.score <= .28).sort((a, b) => a.score - b.score).slice(0, 3);
}

export function clientInitials(name: string): string {
  return name.trim().split(/\s+/u).slice(0, 2).map(part => Array.from(part)[0] || '').join('').toLocaleUpperCase('en');
}
